import { StarsButton, Translation } from '@ps/web-shared-components';
import { Label } from '@ps/web-shared-ui';
import classNames from 'clsx';
import React from 'react';
import { useForm, useFormState } from 'react-final-form';

import type { FormValues } from '../../ESGamingLimitForm';

import {
  TXTACL_1_Hour,
  TXTACL_N0_Hours,
  TXTACL_Restriction_Time
} from './FuturePlayRestrictionTimeSelect.messages.json';
import styles from './FuturePlayRestrictionTimeSelect.scss';

const TIME_OPTIONS = [
  {
    value: 1,
    translationKey: TXTACL_1_Hour
  },
  {
    value: 4,
    translationKey: TXTACL_N0_Hours
  },
  {
    value: 12,
    translationKey: TXTACL_N0_Hours
  },
  {
    value: 24,
    translationKey: TXTACL_N0_Hours
  }
];

const FuturePlayRestrictionTimeSelect: React.FunctionComponent = () => {
  const {
    values: { blockAmount }
  } = useFormState<FormValues>();
  const { change } = useForm<FormValues>();

  return (
    <div>
      <div>
        <Label id="exclusion-time" className={styles.label}>
          <Translation {...TXTACL_Restriction_Time} />
        </Label>
        <div className={styles.wrapper}>
          {TIME_OPTIONS.map(({ value, translationKey }) => {
            const blockAmountMinutes = value * 60;
            const isSelected = blockAmount === blockAmountMinutes;
            return (
              <StarsButton
                key={`restriction-time-option--${value}`}
                variant="form"
                values={{ 0: value }}
                translation={translationKey}
                onClick={() => change('blockAmount', blockAmountMinutes)}
                className={classNames(styles.button, { [styles.selected]: isSelected })}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default FuturePlayRestrictionTimeSelect;
